import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import { appColors } from '../../Config/Theme';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface AppBreadcrumbsProps {
  items: BreadcrumbItem[];
}

const AppBreadcrumbs: React.FC<AppBreadcrumbsProps> = ({ items }) => {
  const navigate = useNavigate();

  return (
    <MuiBreadcrumbs
      separator={<NavigateNext sx={{ fontSize: 16, color: appColors.text.placeholder }} />}
      sx={{ mb: 1 }}
    >
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        if (isLast || !item.path) {
          return (
            <Typography
              key={idx}
              variant="body2"
              sx={{
                color: isLast ? appColors.text.heading : appColors.text.caption,
                fontWeight: isLast ? 600 : 400,
                fontSize: '0.85rem',
              }}
            >
              {item.label}
            </Typography>
          );
        }
        return (
          <Link
            key={idx}
            component="button"
            variant="body2"
            underline="hover"
            onClick={() => navigate(item.path!)}
            sx={{
              color: appColors.primary.main,
              fontWeight: 500,
              fontSize: '0.85rem',
              cursor: 'pointer',
            }}
          >
            {item.label}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
};

export default AppBreadcrumbs;
